import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { Box, Typography, AbsoluteBox, InputField, Grid } from '@kis-technologies/kis-ui';
import { NumPadAction } from 'components/NumPad';
import { useKeyboard } from 'hooks/useKeyboard';
import { selectors as configSelectors, Messages } from 'services/configuration';
import { selectors as ticketingSelectors } from 'services/ticketing';
import { DEFAULT_TEXT } from '../strings';
import { useStyles } from '../styled';
import { ManualEntryProps } from '../types';

export const ManualEntry = (props: ManualEntryProps) => {
  const { onCancel, onSubmit, value: preValue } = props;
  const { t, i18n } = useTranslation();

  const configuration = useSelector(configSelectors.selectConfiguration);
  const ticketingPath = useSelector(ticketingSelectors.selectTicketingConfigPath);

  const messages: Messages = get(configuration, `${ticketingPath}.souvenirTicket.ticketEntry.manualEntry.messages`, {});
  const headerText = get(messages, `header.${i18n.language}`, DEFAULT_TEXT.manualEntryHeader);
  const subheaderText = get(messages, `subheader.${i18n.language}`, DEFAULT_TEXT.manualEntrySubheader);
  const placeholderText = get(messages, `placeholder.${i18n.language}`, DEFAULT_TEXT.manualEntryPlaceholder);
  const backButtonText = get(messages, `buttons.${i18n.language}[0]`, t('commonText.back'));
  const nextButtonText = get(messages, `buttons.${i18n.language}[1]`, t('commonText.next'));

  const [value, setValue] = useKeyboard(preValue);

  const classes = useStyles();

  const handleNumpadClick = (_: React.MouseEvent<HTMLButtonElement>, v: string) => setValue(v);

  return (
    <>
      <Grid className={classes.manualEntryOuterContainer}>
        <Grid className={classes.manualEntryInnerContainer}>
          <div className={classes.manualEntryHeadingDiv}>
            <Box flexOverride="none" margin="6">
              <Typography fontSize={72} fontWeight={800} align="center">
                {headerText}
              </Typography>
            </Box>
            <Typography className={classes.manualEntrySubheader}>{subheaderText}</Typography>
            <div className={classes.manualEntryInputFieldDiv}>
              <InputField autoFocus size="large" align="center" placeholder={placeholderText} fullWidth value={value} />
            </div>
          </div>
          <AbsoluteBox raised fullWidth bg="x-light-gray" bottom="0" left="0">
            <Grid>
              <NumPadAction
                onClick={handleNumpadClick}
                onConfirm={() => onSubmit(value)}
                onBack={onCancel}
                isConfirmDisabled={value.length < 1}
                confirmConfig={{
                  label: nextButtonText,
                  backLabel: backButtonText,
                  customSize: 'x-large',
                  width: 475,
                  appearance: 'primary'
                }}
              />
            </Grid>
          </AbsoluteBox>
        </Grid>
      </Grid>
    </>
  );
};
